import { formatAresDateTime } from './aresDateTime';

export function formatDuration(minutes: number): string {
  if (minutes == null || isNaN(minutes)) return '-';
  if (minutes < 60) {
    return `${Math.round(minutes)} min`;
  }
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  if (mins === 0) {
    return `${hours}h`;
  }
  return `${hours}h ${mins}min`;
}

export function formatTimestamp(timestamp: string): string {
  try {
    return formatAresDateTime(timestamp).time;
  } catch {
    return timestamp;
  }
}

export function formatDistance(km: number): string {
  if (km == null || isNaN(km)) return '-';
  if (km < 1) {
    return `${Math.round(km * 1000)} m`;
  }
  return `${km.toFixed(1)} km`;
}
